import {
  Fetch
} from '@/utils/fetch'

class Login {
  /**
   * 当前程序的授权模块代码
   */
  ModuleCode: string = process.env.MODULE_CODE
  /**
   * 登陆
   * @param userInfo 用户信息
   */
  login (userInfo) {
    return Fetch.fetch({
      url: 'token',
      method: 'post',
      data: userInfo
    })
  }

  /**
   * 快捷登陆
   * @param data 数据
   */
  shortcutLogin (data) {
    return Fetch.fetch({
      url: 'token/shortcutToken',
      method: 'get',
      params: data
    })
  }

  /**
   * 退出
   * @export
   */
  logout () {
    return Fetch.fetch({
      url: 'token/logout',
      method: 'post'
    })
  }

  /**
   * 获取用户信息
   * @export
   * @returns
   */
  getUserInfo () {
    return Fetch.fetch({
      url: 'token',
      method: 'get'
    })
  }

  /**
   * 修改密码
   * @export
   * @returns
   */
  changePwd (data) {
    return Fetch.fetch({
      url: 'token/changePwd',
      method: 'post',
      data: data
    })
  }

  /**
   * 获取快捷登录用户
   * @export
   */
  getReturnData (k) {
    return Fetch.fetch({
      baseURL: `${process.env.GetShortcutData_URL}`,
      method: 'post',
      data:{
        refer:k,
        m:this.ModuleCode
      }
    })
  }

  /**
   * 获取微信二维码
   * @export
   */
  getWxQR (r) {
    return Fetch.fetch({
      baseURL: `${process.env.GetWxQR_URl}&r=${r}`,
      method: 'get'
    })
  }
}

let LoginApis = new Login()
export default LoginApis
